<template>
  <div class="right-img">
    <img
      :width="(1106 / 100) * 30"
      src="https://oss.baiweicaijing.com/v3/uploads/images/2025/07/30/856990a3bed83140d9a0aebc3574ffb2b946e.jpg"
      alt=""
    />
  </div>
</template>
    
<script>
export default {
  name: "",
  data() {
    return {};
  },
  methods: {},
};
</script>
    
<style scoped>
.right-img {
  position: fixed;
  top: 250px;
  right: 20px;
  z-index: 100;
}
</style>